module.exports = new __parcel__URL__("MagnumMarketing_Black.4d0d5bbb.svg").toString();